import React, { useEffect, useRef, useState } from 'react';
import { Section } from '../../Section/Section';
import { FormattedText, formatText } from 'core/i18n';
import { LegalInfo } from '../../LegalInfo/LegalInfo';
import CheckBox from 'components/checkBox/checkBox';
import { CREDIT_CARD } from 'constants/userProfile';
import { Documentation } from '../../documentation/Documentation';
import { SECTION_TYPE } from '../../constants';
import scroll from 'utilities/scroll';
import { usePrecontractualDocsReset } from 'components/newAccountSteps/initialStep/sections/PrecontractualDocs/hooks/usePrecontractualDocsReset';
import { doTagIsValidAndGoNext } from 'components/newAccountSteps/initialStep/sections/PrecontractualDocs/tagging';

export const PrecontractualDocs = ({
    actions,
    formActions,
    handleModifySection,
    handleValidateSection,
    isCollapsed,
    isValidated,
    preLoaderActions,
    promotionalCode,
    readyCaptchaToken,
    userProfile,
    userProfileForm,
}) => {
    const { onboardingType, precontractualDocNames, precontractualDocsOK, investmentType, jointHolderData } =
        userProfile;
    const [isReaded, setIsReaded] = useState(false);
    const documentsRef = useRef(null);
    usePrecontractualDocsReset({
        onboardingType,
        openDebitCard: jointHolderData?.invite.openDebitCard,
        getPrecontractualDocumentNames: actions.getPrecontractualDocumentNames,
        formActions,
        setIsReaded,
    });

    useEffect(() => {
        isCollapsed && formActions.setValidity('userProfile.password', { required: true });
    }, [isCollapsed]);

    const getDocuments = (onboardingType, callback) => {
        const url = promotionalCode?.get('promotionalCode').get('url');
        const infoArray = [formatText('button-contractWait'), formatText('button-preContractGenerating')];

        preLoaderActions.setInformationArray(infoArray);
        preLoaderActions.showPreLoader();
        readyCaptchaToken(captcha => {
            actions.precontractualProcess(
                onboardingType,
                jointHolderData?.invite.openDebitCard,
                url,
                callback,
                captcha
            );
        });
    };
    const saveTimeDocAccept = ({ dmsDocumentId, documentType, checksum }) => {
        const now = new Date();
        const newSaveTimeDocAccept = [
            ...userProfile.saveTimeDocAccept,
            { dmsDocumentId, documentType, checksum, date: now.toISOString() },
        ];
        formActions.change('userProfile.saveTimeDocAccept', newSaveTimeDocAccept);
        if (userProfile.precontractualDocNames.length === newSaveTimeDocAccept.length) setIsReaded(true);
        scroll.transition(documentsRef?.current);
    };

    const isButtonDisabled = !userProfileForm.$form.valid || !precontractualDocsOK || !isReaded;

    const scrollToDocModalRow = () => {
        scroll.transition(documentsRef?.current);
    };

    const onValidateSection = () => {
        if (isButtonDisabled) return;
        doTagIsValidAndGoNext();
        handleValidateSection();
    };

    return (
        <Section
            type={SECTION_TYPE.PRECONTRACTUAL_DOCS}
            isCollapsed={isCollapsed}
            isValidated={isValidated}
            handleModifySection={handleModifySection}
            handleValidateSection={onValidateSection}
            isButtonDisabled={isButtonDisabled}
            userProfile={userProfile}
            promoCode={promotionalCode?.get('promotionalCode').get('code')}
        >
            {investmentType === CREDIT_CARD ? (
                <>
                    <LegalInfo />
                    <div className="row">
                        <div className="col-sm-12 check-box__legal">
                            <CheckBox
                                listClassName="field_acceptClause"
                                profileModel="userProfile.acceptTerms"
                                fieldsRequired="1"
                                checkBoxList={[
                                    {
                                        label: <FormattedText value="field-acceptClausuleCreditCard" />,
                                        model: 'userProfile.acceptTerms',
                                        onChange: e => {
                                            setIsReaded(e);
                                        },
                                    },
                                ]}
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                formActions={formActions}
                                remarkable={true}
                                checked={true}
                                messagesError={{
                                    required: formatText('validation-fieldRequiredDataProtectionClause'),
                                }}
                                errorStyle="form__field_error_remarkable"
                            />
                        </div>
                    </div>
                </>
            ) : (
                <div ref={documentsRef} id="documentationModalRow">
                    <Documentation
                        onClose={scrollToDocModalRow}
                        getDocuments={getDocuments}
                        isDocumentsLoaded={precontractualDocsOK}
                        onDocumentAcceptance={saveTimeDocAccept}
                        precontractualDocNames={precontractualDocNames}
                        profileOnboardingType={onboardingType}
                    />
                </div>
            )}
        </Section>
    );
};
